"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlannerDayCourseList = void 0;
var material_1 = require("@mui/material");
var il_card_group_assignment_1 = require("../il-card-group-assignment/il-card-group-assignment");
var react_1 = __importDefault(require("react"));
var assignment_state_enum_1 = require("../../shared/enums/assignment-state.enum");
var typeography_common_1 = require("../typeography/typeography.common");
function PlannerDayCourseList(_a) {
    var assignmentGroupArgs = _a.assignmentGroupArgs, noEnrollments = _a.noEnrollments, selectAssignment = _a.selectAssignment;
    var element = (react_1.default.createElement(material_1.List, { sx: { my: 0, pt: 0 } }, __spreadArray([], assignmentGroupArgs, true).sort(function (group1, group2) {
        return isCourseOverdue(group2) - isCourseOverdue(group1) ||
            group1.assignmentProps[0].courseTitle.localeCompare(group2.assignmentProps[0].courseTitle);
    })
        .map(function (assignmentGroupArg, index) {
        return (react_1.default.createElement(react_1.default.Fragment, { key: index },
            react_1.default.createElement(material_1.ListItem, { sx: { my: 0, py: '0.125rem' } },
                react_1.default.createElement(il_card_group_assignment_1.IlCardGroupAssignment, __assign({}, assignmentGroupArg, { selectAssignment: selectAssignment })))));
    })));
    if (assignmentGroupArgs.length === 0) {
        var message = noEnrollments
            ? 'This student doesn’t have any courses assigned yet'
            : 'Nothing Assigned Today';
        element = (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: 'center' } },
            react_1.default.createElement(typeography_common_1.ILBody2, { sx: { color: 'text.disabled', display: 'flex', textAlign: 'center' } }, message)));
    }
    return element;
}
exports.PlannerDayCourseList = PlannerDayCourseList;
function isCourseOverdue(group) {
    return group.assignmentProps.some(function (assignmentProps) { return assignmentProps.assignmentState === assignment_state_enum_1.AssignmentStateEnum.OVERDUE; })
        ? 1
        : 0;
}
